import { useEffect } from "react";

const SITE_URL = "https://www.meesterstoffeerders.nl";
const DEFAULT_TITLE = "Meester Stoffeerders | Meubelstoffering en Restauratie in Almere";
const DEFAULT_DESCRIPTION =
  "Meester Stoffeerders in Almere voor meubelstoffering, restauratie, maatwerk en herstoffering van banken, stoelen en fauteuils.";
const DEFAULT_IMAGE = `${SITE_URL}/logo512.png`;

const setOrCreateMeta = (selector, attributes) => {
  let element = document.head.querySelector(selector);

  if (!element) {
    element = document.createElement("meta");
    document.head.appendChild(element);
  }

  Object.entries(attributes).forEach(([key, value]) => {
    element.setAttribute(key, value);
  });
};

const setOrCreateLink = (selector, attributes) => {
  let element = document.head.querySelector(selector);

  if (!element) {
    element = document.createElement("link");
    document.head.appendChild(element);
  }

  Object.entries(attributes).forEach(([key, value]) => {
    element.setAttribute(key, value);
  });
};

const Seo = ({
  title = DEFAULT_TITLE,
  description = DEFAULT_DESCRIPTION,
  path = "/",
  image = DEFAULT_IMAGE,
  noindex = false,
  schema = null,
}) => {
  useEffect(() => {
    const canonicalUrl = `${SITE_URL}${path}`;
    const previousTitle = document.title;

    document.title = title;
    document.documentElement.lang = "nl";

    setOrCreateMeta('meta[name="description"]', {
      name: "description",
      content: description,
    });

    setOrCreateMeta('meta[name="robots"]', {
      name: "robots",
      content: noindex ? "noindex, nofollow" : "index, follow",
    });

    setOrCreateMeta('meta[property="og:title"]', {
      property: "og:title",
      content: title,
    });

    setOrCreateMeta('meta[property="og:description"]', {
      property: "og:description",
      content: description,
    });

    setOrCreateMeta('meta[property="og:type"]', {
      property: "og:type",
      content: "website",
    });

    setOrCreateMeta('meta[property="og:url"]', {
      property: "og:url",
      content: canonicalUrl,
    });

    setOrCreateMeta('meta[property="og:image"]', {
      property: "og:image",
      content: image,
    });

    setOrCreateMeta('meta[name="twitter:card"]', {
      name: "twitter:card",
      content: "summary_large_image",
    });

    setOrCreateMeta('meta[name="twitter:title"]', {
      name: "twitter:title",
      content: title,
    });

    setOrCreateMeta('meta[name="twitter:description"]', {
      name: "twitter:description",
      content: description,
    });

    setOrCreateMeta('meta[name="twitter:image"]', {
      name: "twitter:image",
      content: image,
    });

    setOrCreateLink('link[rel="canonical"]', {
      rel: "canonical",
      href: canonicalUrl,
    });

    let schemaElement = document.head.querySelector('script[data-seo-schema="true"]');

    if (schema) {
      if (!schemaElement) {
        schemaElement = document.createElement("script");
        schemaElement.type = "application/ld+json";
        schemaElement.setAttribute("data-seo-schema", "true");
        document.head.appendChild(schemaElement);
      }

      schemaElement.textContent = JSON.stringify(schema);
    } else if (schemaElement) {
      schemaElement.remove();
    }

    return () => {
      document.title = previousTitle;
    };
  }, [description, image, noindex, path, schema, title]);

  return null;
};

export default Seo;
export { SITE_URL, DEFAULT_IMAGE };
